import React, { useEffect } from "react";
import { Tree, Spin, Empty, Space } from "antd";
import useQuizDrawer from "Pages/MySchedule/MyScheduledBeta/quiz/hooks/useQuizDrawer";
import { BASE_URL } from "utilFunctions/Constants/urlConstants";

interface CourseSelectionProps {
  selectedCourse: string;
  onTreeChange?: any;
  selectedKeys?: any[];
  expandedKeys?: any[];
}

const CourseSelection: React.FC<CourseSelectionProps> = ({
  selectedCourse,
  onTreeChange,
  selectedKeys,
}) => {
  //   const [selectedCourse, setSelectedCourse] = useState<string>();

  const {
    isTreeLoading,
    setIsTreeLoading,
    treeData,
    setTreeData,
    fetchTreeData,
  } = useQuizDrawer();

  const { courseToc = [] } = treeData || {};

  useEffect(() => {
    if (!selectedCourse) return;

    setIsTreeLoading(true);
    setTreeData([]);

    fetchTreeData(
      BASE_URL +
        `syllabusCompliance/course/toc?courseId=${selectedCourse}&fullToc=true`
    );
  }, [selectedCourse]);

  // ---------------- HELPERS ----------------
  const buildNodeMap = (nodes: any[], map = new Map()) => {
    nodes.forEach((node) => {
      map.set(node.key, node);
      if (node.children?.length) {
        buildNodeMap(node.children, map);
      }
    });
    return map;
  };
  const isUnderSelectedChapter = (
    node: any,
    chapterSelected: Set<number>,
    nodeMap: Map<number, any>
  ) => {
    let current = node;

    while (current?.parentNode) {
      if (chapterSelected.has(current.parentNode)) return true;
      current = nodeMap.get(current.parentNode);
    }

    return false;
  };

  const segregateSelectedNodes = (treeData: any[], selectedNodes: any[]) => {
    const chapterIds = new Set<number>();
    const nodeIds = new Set<number>();

    const nodeMap = buildNodeMap(treeData);

    const chapterSelected = new Set(
      selectedNodes.filter((n) => n.nodeType === "Chapter").map((n) => n.key)
    );

    selectedNodes.forEach((node) => {
      const { key, nodeType, children } = node;

      // 1️⃣ Chapter selected → ONLY chapterIds
      if (nodeType === "Chapter") {
        chapterIds.add(key);
        return;
      }

      // ❌ Ignore ANY node under selected chapter
      if (isUnderSelectedChapter(node, chapterSelected, nodeMap)) return;

      // 2️⃣ Topic selected → include all children
      if (nodeType === "Topic") {
        if (children?.length) {
          children.forEach((child: any) => nodeIds.add(child.key));
        } else {
          nodeIds.add(key);
        }
      }

      // 3️⃣ Sub-topic selected
      if (nodeType === "Sub-Topic") {
        nodeIds.add(key);
      }
    });

    return {
      chapterIds: Array.from(chapterIds),
      nodeIds: Array.from(nodeIds),
    };
  };

  // ---------------- UI ----------------

  return (
    <Space direction="vertical" style={{ width: "100%" }} size={16}>
      {/* Course Select */}

      {/* Tree Section */}
      {isTreeLoading && <Spin />}

      {!isTreeLoading && selectedCourse && courseToc?.length === 0 && (
        <Empty description="No data available" />
      )}

      {!isTreeLoading && courseToc?.length > 0 && (
        <Tree
          checkable
          selectedKeys={selectedKeys}
          checkedKeys={selectedKeys}
          treeData={courseToc}
          onCheck={(checkedKeys, info) => {
            const result = segregateSelectedNodes(
              courseToc,
              info.checkedNodes as any[]
            );

            onTreeChange?.(result);
            console.log("Segregated Result:", result);
          }}
        />
      )}
    </Space>
  );
};

export default CourseSelection;
